import type { SyntheticEvent } from 'react';

/** Marks the editor's own DOM (control, pencils, dialog, notices): never scanned for markers, never treated as app. */
export const EDITOR_UI_ATTRIBUTE = 'data-text-overrides-ui';

export const isInsideEditorUi = (target: EventTarget | null): boolean =>
  target instanceof Element && target.closest(`[${EDITOR_UI_ATTRIBUTE}]`) !== null;

const stop = (e: SyntheticEvent) => e.stopPropagation();

/**
 * Presses and clicks on the editor's own controls must not reach the app: menus and popovers close on a click away
 * (document listeners). React 17 dispatches a portal's events at its container, so stopping there keeps the native
 * event away from document listeners.
 */
export const STOP_HANDLERS = {
  onClick: stop,
  onMouseDown: stop,
  onMouseUp: stop,
  onPointerDown: stop,
  onPointerUp: stop,
  onTouchStart: stop,
  onTouchEnd: stop,
} as const;
